var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['input-image-box', { active: _vm.isActive, inactive: !_vm.isActive }],style:({ backgroundImage: ("url(" + _vm.image + ")") }),on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }